export const textFonts =[

    ["Open Sans","Open Sans"],
    ["Times New Roman","Times New Roman"],
    ["Arial","Arial"],
    ["Lucida Console","Lucida Console"],
    ["Ubuntu","Ubuntu"],
    ["Escolar","Escolar"]
    
]